import { CreateBase, Form, useTranslate } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";
import { useIsMobile } from "@/hooks/use-mobile";

import { FormToolbar } from "../layout/FormToolbar";
import { CompanyInputs } from "./CompanyInputs";
import { MobileFormToolbar, MobilePage } from "../layout/MobilePage";

export const CompanyCreate = () => {
  const isMobile = useIsMobile();
  return (
    <CreateBase redirect="show">
      {isMobile ? <CompanyCreateMobile /> : <CompanyCreateDesktop />}
    </CreateBase>
  );
};

const CompanyCreateDesktop = () => {
  const translate = useTranslate();
  return (
    <div className="mt-2 flex lg:mr-72">
      <div className="flex-1">
        <h2 className="text-2xl font-bold tracking-tight mb-4">
          {translate("resources.companies.action.create")}
        </h2>
        <Form>
          <Card>
            <CardContent>
              <CompanyInputs />
              <FormToolbar />
            </CardContent>
          </Card>
        </Form>
      </div>
    </div>
  );
};

const CompanyCreateMobile = () => {
  const translate = useTranslate();
  return (
    <MobilePage
      title={translate("resources.companies.action.create")}
      backTo="/companies"
    >
      <Form className="flex flex-col gap-4">
        <CompanyInputs />
        <MobileFormToolbar />
      </Form>
    </MobilePage>
  );
};
